import { gql } from '@apollo/client';

const allFields = `
  id
  customerId
  managedEntityId
  paymentSourceId
  paymentDay
  paymentAmountType
  amount
  type
  createdAt
`;

export const CREATE_AUTOPAY_SCHEDULE = gql`
mutation CreateAutopaySchedule($data: CreateAutopayScheduleData) {
  createAutopaySchedule(data: $data) {
    ${allFields}
  }
}
`;

export const FIND_ALL_AUTOPAY_SCHEDULES = gql`
query FindAllAutopaySchedules($where: JSONObject) {
  findAutopaySchedule(where: $where) {
    ${allFields}
  }
}
`;

export const DELETE_AUTOPAY_SCHEDULE = gql`
  mutation DeleteAutopaySchedule($id: String) {
    deleteAutopaySchedule(id: $id)
  }
`;

export const UPDATE_AUTOPAY_SCHEDULE = gql`
mutation UpdateAutopaySchedule($id: String, $data: UpdateAutopayScheduleData) {
  updateAutopaySchedule(id: $id, data: $data) {
    ${allFields}
  }
}
`;
